import agent from "../../services/agent";
import moment from "moment";
import {
  clearEnableUserError,
  clearLoginUserError,
  enableUserPending,
  enableUserPendingError,
  enableUserPendingSuccess,
  loginUserError,
  loginUserPending,
  loginUserPendingSuccess,
  loginUserSuccess,
  activateUserError,
  activationSuccess,
  setActivationPending,
  clearActivationPending,
  setActivationErrorMessage,
  enableUserError,
  setLoginSuccessMessage
} from "./login.actions";

import {
  clearSignupUserError,
  signupUserError,
  signupUserPending,
  signupUserPendingError,
  signupUserPendingSuccess,
} from './signup.actions';

import {
  SET_CURRENT_PROFILE,
  SET_FORGOT_PASSWORD_CONFIRMATION_STATUS,
  SET_LOGIN_REDIRECT,
  SET_EMAIL_ADDRESS,
  SET_RESET_PASSWORD_BOOLEAN,
  SET_PROFILE_DETAILS,
  SET_FORGOT_PASSWORD_ERROR_MESSAGE,
  SET_EDIT_PROFILE_SUCCESS_MESSAGE,
  SET_EDIT_PROFILE_ERROR_MESSAGE,
  SET_LOGIN_REDIRECT_FROM_RESET_PASSWORD,
  SET_IS_GET_PROFILE_PENDING,
  SET_IS_EDIT_PROFILE_PENDING,
} from "../constants/profile.constants";

import { setCloseEditUserModal } from "../../store/actions/users.actions.js";

import { ProfileState } from "../../types/profile";
import { clearForm } from "./form.actions";
import { showSnackbarStatus } from "./snackbar.actions";
import { getToken } from "../../helpers/common";

const handleServerError = (dispatch: Function, errorAction: Function, error: any, message?: string) => {
  dispatch(errorAction());
  console.error(message || "Server error:", error);
  if (error?.response?.body?.message) {
    dispatch(errorAction(error.response.body.message));
  } else {
    dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
  }
};

// Action Creators
export const setCurrentProfile = (currentProfile: ProfileState): Action => ({
  type: SET_CURRENT_PROFILE,
  payload: currentProfile,
});

export const setForgotPasswordConfirmationStatus = (status: string): Action => ({
  type: SET_FORGOT_PASSWORD_CONFIRMATION_STATUS,
  payload: status,
});

export const setForgotPasswordErrorMessage = (forgorPasswordErrorMessage): Action => ({
  type: SET_FORGOT_PASSWORD_ERROR_MESSAGE,
  payload: forgorPasswordErrorMessage,
});


export const setLoginRedirect = (data): Action => ({
  type: SET_LOGIN_REDIRECT,
  payload: data,
});

export const setLoginRedirectFromResetPassword = (data): Action => ({
  type: SET_LOGIN_REDIRECT_FROM_RESET_PASSWORD,
  payload: data,
})

export const setEmailAddress = (data): Action => ({
  type: SET_EMAIL_ADDRESS,
  payload: data
});

export const setResetPasswordBoolean = (data): Action => ({
  type: SET_RESET_PASSWORD_BOOLEAN,
  payload: data
});

export const setProfileDetails = (data): Action => ({
  type: SET_PROFILE_DETAILS,
  payload: data
});

export const setEditProfileSuccessMessage = (data): Action => ({
  type: SET_EDIT_PROFILE_SUCCESS_MESSAGE,
  payload: data
});

export const setEditProfileErrorMessage = (data): Action => ({
  type: SET_EDIT_PROFILE_ERROR_MESSAGE,
  payload: data
});

export const setISGetProfilePending = (data): Action => ({
  type: SET_IS_GET_PROFILE_PENDING,
  payload: data
});

export const setIsEditProfilePending = (data): Action => ({
  type: SET_IS_EDIT_PROFILE_PENDING,
  payload: data
});


export const setTokenDetails = (authData: any) => {
  const { accessToken, tokenType, expiresInSec } = authData;
  const expires = moment().unix() + expiresInSec;
  sessionStorage.setItem('accessToken', accessToken);
  sessionStorage.setItem('expiresInSec', expires);
  sessionStorage.setItem('token_type', tokenType);
};

export const userLogin = (email: string, password: string) => async (dispatch: Function) => {
  dispatch(loginUserPending());
  dispatch(clearLoginUserError());
  agent.Auth.login(email, password)
    .then((authData) => {
      setTokenDetails(authData);
      dispatch(loginUserPendingSuccess());
      dispatch(loginUserSuccess(email, authData.accessToken, authData.expiresInSec));
      dispatch(getProfileDetails());
    })
    .catch((err) => {
      if (err && err.response && err.response.body) {
        dispatch(loginUserError("Incorrect password or email"));
      } 
      else if(err && err.response && err.response.text){
        dispatch(loginUserError(err && err.response && err.response.text))
      }
      else {
        dispatch(loginUserError("Something went wrong"));
      }
    });
};

export const enableUserAccount = (code: string) => async (dispatch: Function, getState: Function) => {
  try {
    dispatch(enableUserPending());
    dispatch(clearEnableUserError());
    await agent.Auth.enableAccount(code);
    //const result = await agent.Auth.enableAccount(code);
    // dispatch(userLogin(result, formCompleteRegistration.password));
    // if(result === true)
    // {
    //   dispatch(setLoginRedirect(result));
    // }
    // else{
    //   dispatch(loginUserError(result))
    // }
    dispatch(setLoginRedirect(true));
    dispatch(enableUserPendingSuccess());
    dispatch(clearForm());
    dispatch(setLoginSuccessMessage("Your account has been successfully verified. Try log in"));
    dispatch(loginUserError(""))
  } catch (error) {
    dispatch(loginUserError(error && error.response && error.response.text));
    dispatch(setLoginSuccessMessage(""))
    dispatch(setLoginRedirect(true));
    handleServerError(dispatch, enableUserPendingError, error, "Enable user account failed");
    dispatch(enableUserPendingSuccess());
    dispatch(clearForm());
  }
};

export const forgotPassword = (email: string) => async (dispatch: Function) => {
  try {
    dispatch(setForgotPasswordConfirmationStatus("INPROGRESS"));
    await agent.Auth.forgotPassword(email);
    dispatch(setForgotPasswordConfirmationStatus("EMAIL_SENT"));
    dispatch(clearForm());
  } catch (error) {
    dispatch(setForgotPasswordConfirmationStatus("INVALID_EMAIL"));
    dispatch(setForgotPasswordErrorMessage(error && error.response && error.response.text))
  }
};

export const getEmailAddress = (code) => async (dispatch: Function) => {
  try {
    console.timeLog("code",code)
    const result = await agent.Auth.getEmailAddress(code);
    dispatch(setEmailAddress(result && result.email));
    dispatch(setResetPasswordBoolean(true));
    dispatch(setLoginRedirectFromResetPassword(false));
  }
  catch (error) {
    dispatch(loginUserError(error && error.response && error.response.text));
    dispatch(setLoginRedirectFromResetPassword(true));
  }
};

export const resetPassword = (email: string) => async (dispatch: Function, getState: Function) => {
  try {
    const { formResetPassword } = getState()?.form;
    dispatch(clearEnableUserError());
    dispatch(enableUserPending());

    await agent.Auth.resetPassword(formResetPassword, email);
    // dispatch(userLogin(result, formResetPassword.password));
    dispatch(setLoginRedirectFromResetPassword(true));
    dispatch(enableUserPendingSuccess());
    dispatch(clearForm());
    dispatch(setLoginSuccessMessage("Your password has been updated successfully. You can now try log in."))
  } catch (error) {
    handleServerError(dispatch, enableUserPendingError, error, "Reset password failed");
    dispatch(setLoginSuccessMessage(""));
    dispatch(enableUserError(`${error && error.response && error.response.text}`));
    dispatch(enableUserPendingSuccess());
    dispatch(clearForm());
  }
};

export const userSignUp = (username: string, email: string, password: string, re_password: string) => async (dispatch: Function) => {
  try {
    dispatch(signupUserPending());
    dispatch(clearSignupUserError());
    const authData = await agent.Auth.signup(username, email, password, re_password);
    // if(authData === true)
    // {
    //   dispatch(signupUserError("A verification email has been sent. Please Activate your account using the Link in your email."));
    // }
    console.log(authData);
    // const currentUser = await agent.Auth.getCurrentUser(authData.id_token);

    dispatch(signupUserPendingSuccess());
    // dispatch(setCurrentProfile(currentUser));
    // dispatch(signupUserSuccess(currentUser.email, authData.id_token, authData.expires_in));
  }
  catch (error) {
    dispatch(signupUserError(error && error.response && error.response.text));
    handleServerError(dispatch, signupUserPendingError, error, "User signup failed");
  }
}

export const activateUser = (encodedMess) => async (dispatch: Function) => {
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  try {
    const jsonString = atob(encodedMess);
    const { email, code } = JSON.parse(jsonString);
    console.log(encodedMess);
    console.log(email, code);
    dispatch(setActivationErrorMessage(null));
    dispatch(activateUserError());
    dispatch(setActivationPending());
    await wait(4000);
    const activateData = await agent.Auth.checkActivation(email, code);
    dispatch((clearActivationPending()));
    if (activateData.valid) {
      dispatch(activationSuccess());
    }
    else {
      dispatch(setActivationErrorMessage("Issue in verifying your account.Please try again."));
    }
  } catch (error) {
    dispatch((clearActivationPending()));
    dispatch(setActivationErrorMessage("Issue in verifying your account.Please try again."));
  }
}

export const getProfileDetails = () => (dispatch: Function) => {
  dispatch(setISGetProfilePending(false));
  return getToken(dispatch).then((accessToken) => {
    return agent.Auth.getProfile(accessToken)
      .then((data) => {
        dispatch(setProfileDetails(data));
        dispatch(setISGetProfilePending(true));
        return Promise.resolve(data);
      })
      .catch((err) => {
        if (err && err.response && err.response.text) {
          dispatch(showSnackbarStatus(`Unable to Get Profile Details, ${err && err.response && err.response.text}`));
          return;
        }
        else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const editProfile = (data) => (dispatch: Function) => {
  dispatch(setIsEditProfilePending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Auth.editProfile(accessToken, data)
      .then((eventsList) => {
        dispatch(getProfileDetails());
        dispatch(showSnackbarStatus(`Profile Updated`));
        dispatch(setEditProfileSuccessMessage("Profile deatils updated"));
        dispatch(setEditProfileErrorMessage(""));
        dispatch(setCloseEditUserModal());
        dispatch(setIsEditProfilePending(false));        
      })
      .catch((err) => {
        dispatch(setIsEditProfilePending(false));
        dispatch(setEditProfileSuccessMessage(""));
        if (err && err.response && err.response.text) {
          dispatch(
           setEditProfileErrorMessage(`Unable to update profile ${err && err.response && err.response.text}`)
          );
        }
        else {
          dispatch(
            setEditProfileErrorMessage(`Something went wrong`)
           );
        }
      });
  });
};